export const MIN_SUGGESTION_QUERY_LENGTH = 3;

export type SearchSuggestion = {
    houseId?: number;
    label: string;
    value: string;
};

export type RelatedSuggestions = {
    suggestions: SearchSuggestion[];
    title: string;
};

export type SearchSuggestionsSlice = {
    error: boolean;
    loading: boolean;
    secondarySuggestions: SearchSuggestion[];
    success: boolean;
    suggestions: SearchSuggestion[];
};

export const defaultSearchSuggestionsSlice: SearchSuggestionsSlice = {
    error: false,
    loading: false,
    secondarySuggestions: [],
    success: false,
    suggestions: [],
};
